import { Container } from "reactstrap";
import OnlyHeader from "components/Layout/OnlyHeader.js";
import RequestTable from "components/Requests/RequestsTable";

const Requests = () => {
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <RequestTable />
      </Container>
    </>
  );
};

export default Requests;
